import OverviewSection from '../../../common/components/overviewSection/OverviewSection'
import IIncidentOverview from '../../../common/interfaces/incidentOverview/IIncidentOverview'
import IUserGuide from '../../../common/interfaces/userGuide/IUserGuide'
import IUserGuideTopic from '../../../common/interfaces/userGuide/IUserGuideTopic'
import IUserGuideTopicLanguageContentVideo from '../../../common/interfaces/userGuide/IUserGuideTopicLanguageContentVideo'

import { currentLanguageCode } from "../../../configuration"

import UserGuideData from './userGuideData/userGuide.json';

import './UserGuide.scss'
import { useEffect, useState } from 'react'
import React from 'react';
import IUserGuideTopicLanguageContent from '../../../common/interfaces/userGuide/IUserGuideTopicLanguageContent'
import UserGuideTopicLanguageContentVideo from './UserGuideTopicLanguageContentVideo'
import ICustomer from '../../../common/interfaces/customer/ICustomer'
import ICustomerSupportEntity from '../../../common/interfaces/customer/ICustomerSupportEntity'

// TODO: When videos are added, warnings appear in debugging tool in browser. These must be gone before releasing with videos.
// ,
// "videos": [
//   {
//     "title": "Introduktion til Sense React",
//     "locationLink": "https://www.youtube.com/shorts/OndIprFAchY",
//     "locationEmbed": "https://www.youtube.com/embed/OndIprFAchY"
//   }
// ]
// TODO: Throws a warning wich disappears if the iframe for videos is removed.
// TODO: [Violation] Added non-passive event listener to a scroll-blocking <some> hændelse. Consider marking event handler as 'passive' to make the page more responsive. See <WEBADRESSE>



type ComponentProps = {
  incidentOverview:null|undefined|IIncidentOverview
  domain: string
  activeUserGuideTopicName:null|undefined|string
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
  customer: ICustomer
}

interface Dictionary<T> {
    [key: string]: T;
}


const UserGuide = (props:ComponentProps) => {

  const [userGuide, setUserGuide] = useState<IUserGuide>()
  const [activeUserGuideTopic, setActiveUserGuideTopic] = useState<IUserGuideTopic>()
  const [activeLanguageContent, setActiveLanguageContent] = useState<IUserGuideTopicLanguageContent>()
  const [topicTitleList, setTopicTitleList] = useState<Dictionary<string>>()
  const [documentationProviderSupportEntity, setDocumentationProviderSupportEntity] = useState<ICustomerSupportEntity>()

  var localTopicTitleList:Dictionary<string> = {}

  useEffect(() => {
    var localUserGuide = UserGuideData
    
    setUserGuide(localUserGuide)
    
    localUserGuide?.topics.map(topic => {
      return topic.languageContents.filter(languageContent => (languageContent.language.toLocaleLowerCase() === currentLanguageCode.toLocaleLowerCase())).map(languageContent => {
        return localTopicTitleList[topic.name] = languageContent.title
      })
    })
    setTopicTitleList(localTopicTitleList)

    const localDocumentationProviderSupportEntity: ICustomerSupportEntity | undefined = 
      props.customer.supportEntities.find(
        supportEntity => {return supportEntity.role.type.toString() === 'DocumentationProvider'}
    )
    if (localDocumentationProviderSupportEntity) setDocumentationProviderSupportEntity(localDocumentationProviderSupportEntity)
  }, [])

  useEffect(() => {
    if (props.activeUserGuideTopicName) applyUserGuideTopic(props.activeUserGuideTopicName)
  }, [topicTitleList])

  useEffect(() => {
    if (topicTitleList) applyUserGuideTopic(props.activeUserGuideTopicName)
  }, [props.activeUserGuideTopicName])
  

  const applyUserGuideTopic = (name:null|undefined|string) => {
    const topic = userGuide?.topics.find(item => item.name === name)
    setActiveUserGuideTopic(topic)
    setActiveLanguageContent(topic?.languageContents.find(languageContent => (languageContent.language.toLocaleLowerCase() === currentLanguageCode.toLocaleLowerCase())))
  }

  const handleOpenUserGuide = (event:any) => {
  
    const result = extractUserGuide()

    var resultBlob = new Blob([result], {type: 'text/html'});
    var url = window.URL.createObjectURL(resultBlob);
    event.preventDefault();
    window.open(url);
  }
  
  const extractUserGuide = () => {

    var languageContent:IUserGuideTopicLanguageContent|null|undefined

    var result:string = 
      '<!DOCTYPE html>' +
      '<html lang="da">' +
      '<head>' +
        '<meta charset="utf-8" />' +
        '<title>Sense React - User Guide</title>' +
        '<style>' +
          
        'html {' +
            'font-family: Montserrat;' +
          '}' +

          '#user-guide-title {' +
            'font-size: 1.2em;' +
            'font-weight: bold;' +
            'margin-bottom: .5em;' +
          '}' +

          '#user-guide-legal-terms {' +
            'font-size: .9em;' +
            'font-style: italic;' +
            'margin-bottom: 2em;' +
          '}' +

          '.topic {' +
            'margin-bottom: 1.86em;' +

            '.topic-title {' +
              'font-size: 1.1em;' +
              'font-weight: bold;' +
              'margin-bottom: .8em;' +
            '}' +

            '.text-headline {' +
              'font-size: .9em;' +
              'margin-top: .6em;' +
              'margin-bottom: .6em;' +
              'font-weight: bold;' +
            '}' +

            '.text {' +
              'font-size: .9em;' +
              'font-weight: normal;' +
              'margin-bottom: .2em;' +       
            '}' +
            
            '.video-section {' +
              'font-size: 1em;' +
              'margin-top: .8em;' +
              'font-weight: bold;' +
              'margin-bottom: .6em;' +
            '}' +

            '.video-link {' +
              'display: block;' +
              'font-size: .9em;' +
              'font-weight: bold;' +
            '}' +

            '.reference-section {' +
              'font-size: 1em;' +
              'margin-top: .8em;' +
              'font-weight: bold;' +
              'margin-bottom: .6em;' +
            '}' +

            '.reference-link {' +
              'display: block;' +
              'font-size: .9em;' +
              'font-weight: normal;' +
              'color:black;' +
            '}' +

          '}' +
        '</style>' +
      '</head>' +
      '<body>' +
        '<div id="user-guide-title">Brugervejledning for Sense React</div>' +
        '<div id="user-guide-legal-terms">Denne vejledning tilhører Sense Information. Kunder der anvender Sense, kan inkludere hele eller dele af denne vejledning i deres undervisningsmateriale, med henblik på at forbedre og udbrede kendskabet og forståelse for Sense. Bemærk at denne kopi af vejledningen, naturligvis ikke opdateres, når leverandøren justerer den grundlæggende brugervejledningen i Sense React. Hvis disse ændringer skal viderebringes, skal et nyt udtræk hentes.</div>'

    if (userGuide) {

      userGuide?.topics.map((userGuideTopic:IUserGuideTopic) => {

        if (userGuideTopic) {
    
          result = result + '<div class="topic" id="' + userGuideTopic.name + '">'
          
          languageContent = userGuideTopic.languageContents.find(languageContent => (languageContent.language.toLocaleLowerCase() === currentLanguageCode.toLocaleLowerCase()))

          if (languageContent) {

            result = result + ('<div class="topic-title">' + languageContent.title + '</div>')

            languageContent.texts?.map((text:string) => {
              result = result + (text.endsWith(':') ? 
                ('<div class="text-headline">' + text + '</div>') : 
                ('<div class="text">' + text + '</div>'))
            })

            if (languageContent.videos) {
              result = result + '<div class="video-section">Video(er) relateret til emnet:</div>'
              languageContent.videos?.map((video:IUserGuideTopicLanguageContentVideo, indexVideo:number) => (
                result = result + '<a class="video-link" href="' + video.locationLink + '">' + video.title + '</a>'
              ))
            }

          }                 

          if (userGuideTopic?.references && userGuideTopic?.references.length > 0) {
            result = result + '<div class="reference-section">Andre relaterede emner:</div>'
            userGuideTopic?.references?.map((referenceTopicName:string) => {
            result = result + '<a class="reference-link" href="#' + referenceTopicName + '">' + (topicTitleList && topicTitleList[referenceTopicName]) + '</a>'
            })
          }

          result = result + '</div>'

        }
      })

    }

    result = result +
      '</body>' +
    '</html>'

    return result
  }

  return (
    <OverviewSection 
      contextID='userGuide' 
      incidentOverview={props.incidentOverview} 
      headerTitle='Hjælp og vejledning'
      headerStatus={'?'}
      handleActiveUserGuideTopicNameChangeRequest={props.handleActiveUserGuideTopicNameChangeRequest}
    >
      <div id='user-guide'>
        <div id='user-guide-topic'>

          <div id='user-guide-topic-language-content-title'>
            {activeLanguageContent?.title}
          </div>

          <div id='user-guide-topic-language-content-texts-section'>
            <div id='user-guide-topic-language-content-texts'>
              {
                activeLanguageContent?.texts &&
                  activeLanguageContent?.texts.map((text:string, indexText:number) => (
                    <React.Fragment key={indexText}>
                      <div>                    
                        {
                          text.endsWith(":") ?
                            <div className='user-guide-topic-language-content-texts-headline language-content-text'>
                              {text}
                            </div> :
                            <div className='user-guide-topic-language-content-texts-normal language-content-text'>
                              {text}
                            </div>
                        }
                      </div>
                    </React.Fragment>
                  ))
              }
            </div>
          </div>

          <div id='user-guide-topic-language-content-videos-section'>
            {
              activeLanguageContent?.videos &&
              activeLanguageContent?.videos?.length > 0 &&
              <div id='user-guide-topic-language-content-videos-section-title' className='section-title'>
                Tilgængelige videoer:
              </div> 
            }
          
            <div className='user-guide-topic-language-content-videos'>
              {
                activeLanguageContent?.videos &&
                activeLanguageContent?.videos.map((video:IUserGuideTopicLanguageContentVideo, indexVideo:number) => (
                <React.Fragment key={indexVideo}
                >
                  <div className='user-guide-topic-language-content-video-title'>
                    {video.title}
                  </div>
                  <div className='user-guide-topic-language-content-video'>
                    <UserGuideTopicLanguageContentVideo 
                      location={video.locationEmbed}
                      title={video.title}
                    />
                  </div> 
                </React.Fragment>
                ))
              }
            </div>
          </div>

          <div id='user-guide-topic-references-section'>
            {
              activeUserGuideTopic?.references && 
              activeUserGuideTopic?.references.length > 0 &&
              <div id='user-guide-topic-references-section-title' className='section-title'>
                Andre relaterede emner:
              </div> 
            }

            <div id='user-guide-topic-references'>
              {
                activeUserGuideTopic?.references &&
                activeUserGuideTopic?.references.map((referenceTopicName:string, indexReferenceTopicName:number) => (
                  <React.Fragment key={indexReferenceTopicName}>
                    <div 
                      className='user-guide-topic-reference' 
                      onClick={() => props.handleActiveUserGuideTopicNameChangeRequest(referenceTopicName)}
                      >
                        {topicTitleList && topicTitleList[referenceTopicName]}
                    </div>
                  </React.Fragment>
                ))
              }

              {
                documentationProviderSupportEntity &&
                <div id='user-guide-topic-references-organization-user-guide'>
                  <a href={documentationProviderSupportEntity.contactInitiation.link} target='_blank' rel="noreferrer">
                    {documentationProviderSupportEntity.name}
                  </a>
                </div>
              }

              {
                <div id='user-guide-copy-user-guide' onClick={handleOpenUserGuide}>
                  Eksporter hele vejledningen
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </OverviewSection>
  )
}

export default UserGuide